import ImageryLayer from '../image-layer/ImageLayer';
import FeatureLayer from '../feature-layer/FeatureLayer';
import { CustomDataSource, Primitive } from 'cesium';
import isNumber from 'lodash-es/isNumber';

class GroupLayer {
    constructor(opt_options) {
        const { index, map, key, name, legend, layerControl = true, layers = [] } = opt_options || {};

        this.map = map;

        this.key = key;

        this.name = name;

        this.legend = legend;

        this.layerControl = layerControl;

        this.layers = layers;

        this.index = index;
    }

    addLayer(layer, groupIndex, mapIndex) {
        if (this.hasLayer(layer)) {
            return;
        }

        if (layer instanceof CustomDataSource || layer instanceof FeatureLayer) {
            this.map.dataSources.add(layer);
        } else if (layer instanceof ImageryLayer) {
            this.map.scene.imageryLayers.add(layer);
        } else if (layer instanceof Primitive) {
            this.map.scene.primitives.add(layer);
        }

        if (layer.layerControl) {
            if (isNumber(groupIndex)) {
                this.layers.splice(groupIndex, 0, layer);
            } else {
                this.layers.push(layer);
            }

            this.map.layers.onChange();
        }
    }

    removeLayer(layer) {
        if (!this.hasLayer(layer)) {
            return;
        }

        if (layer instanceof CustomDataSource || layer instanceof FeatureLayer) {
            this.map.dataSources.remove(layer);
        } else if (layer instanceof ImageryLayer) {
            this.map.scene.imageryLayers.remove(layer);
        } else if (layer instanceof Primitive) {
            this.map.scene.primitives.remove(layer);
        }

        if (layer.layerControl) {
            this.layers = this.layers.filter(v => v !== layer);

            this.map.layers.onChange();
        }
    }

    hasLayer(layer) {
        return this.layers.findIndex(v => v === layer) !== -1;
    }

    getLayers() {
        return this.layers;
    }

    setLayers(layers) {
        this.layers = layers;
    }

    indexOf(layer) {
        return this.layers.findIndex(v => v === layer);
    }

    setVisible(visible) {
        this.show = visible;
        this.layers.map(v => {
            v.show = visible;
        });

        this.map.layers.onChange();
    }

    // 获取图层最后一个 index 值
    getLastIndex = _index => {
        let index = 0;
        const layers = this.layers;
        if (layers?.length) {
            if (_index && layers.findIndex(v => _index < v.zIndex) !== -1) {
                index = layers.findIndex(v => _index < v.zIndex);
            } else {
                index = layers.length - 1;
            }
        }

        return index;
    };
}

export default GroupLayer;
